import React from 'react';
import { FictionalIcon } from '../../customFrontend/parts';
import { ChatappHomeCopy, ChatappLabels } from '../../siteBrands/chatapp/types';

/** chatapp.nl's home page copy, standard Dutch with informal "je". */
export const HOME: ChatappHomeCopy = {
  eyebrow: 'Flirtchat en sexchat voor 18+',
  h1: 'Sexchat en flirtchat,',
  h1Accent: 'gewoon op je telefoon',
  lead: 'Chatapp.nl is de chat voor volwassenen die van een stoute flirt houden. Maak gratis een profiel aan, stuur je eerste berichten zonder te betalen en bepaal zelf hoe ver je gaat.',
  cta: 'Gratis aanmelden',
  notifications: [
    { title: 'Aanmelden is gratis', text: 'Geen creditcard nodig, alleen een nickname.' },
    { title: 'Je eerste berichten zijn gratis', text: 'Kijk eerst rustig of de chat je bevalt.' },
    { title: 'Discreet chatten', text: 'Anderen zien alleen je nickname.' },
  ],
  about: {
    title: 'Wat is Chatapp.nl?',
    paragraphs: [
      <>
        Chatapp.nl is online flirtchat en sexchat voor volwassenen in Nederland, gemaakt voor je telefoon. Je maakt
        een profiel aan onder een nickname, bekijkt profielen, stuurt berichten, flirts en foto’s en speelt Match,
        een snel swipespel met elke dag nieuwe suggesties. Of je nu wilt chatten met vrouwen of met mannen, het gaat
        om het gesprek zelf: een beetje plagen, een beetje durven, en altijd op jouw voorwaarden.
      </>,
      <>
        Chatapp.nl is een entertainmentdienst, geen datingsite. We gebruiken fictieve profielen die als doel hebben
        om met je te flirten. Ze zijn gemarkeerd met een persoonsicoon <FictionalIcon language="nl" /> en fysiek
        contact met deze profielen is niet mogelijk. Wat je krijgt, is een spannend gesprek wanneer jij daar zin in
        hebt.
      </>,
    ],
  },
  steps: {
    title: 'In drie stappen aan het chatten',
    items: [
      { title: 'Kies een nickname', text: 'Geef aan met wie je wilt chatten en bedenk een naam. Het duurt een minuut en kost niets.' },
      { title: 'Stuur gratis je eerste berichten', text: 'Je eerste berichten zijn gratis, dus je kunt een flirt sturen en kijken wie er reageert voordat je iets uitgeeft.' },
      { title: 'Ga verder met credits', text: 'Na de gratis berichten kosten berichten, flirts en foto’s credits. Je koopt alleen een pakket als je dat wilt en ziet elke prijs vooraf.' },
    ],
  },
  reasons: {
    title: 'Waarom chatten op Chatapp.nl',
    items: [
      { title: 'Het gesprek staat voorop', text: 'Profielen zijn er om mee te praten. Begin met een vraag, antwoord met een knipoog en kijk hoe warm het wordt.' },
      { title: 'Wanneer het jou uitkomt', text: 'In de trein, in je pauze of laat op de avond: de chat is dag en nacht open, zonder app.' },
      { title: 'Privé en discreet', text: 'Je chat onder een nickname. Je naam en e-mailadres blijven privé en er gaat niets naar je sociale media.' },
      { title: 'Duidelijk en volwassen', text: 'Alleen voor 18+, prijzen vooraf zichtbaar en fictieve profielen gemarkeerd met een persoonsicoon.' },
    ],
  },
  cities: {
    title: 'Sexchat in jouw stad',
    intro: 'Van de grachten van Amsterdam tot de Waalkade in Nijmegen: kies je stad.',
  },
  faq: {
    title: 'Vragen over Chatapp.nl',
    items: [
      {
        q: 'Kost Chatapp.nl geld?',
        a: <p>Een profiel aanmaken is gratis, en je eerste berichten ook. Daarna kosten berichten, flirts en foto’s credits. Je koopt alleen credits als je verder wilt chatten, en je ziet elke prijs voordat je betaalt.</p>,
      },
      {
        q: 'Heb ik een creditcard nodig om me aan te melden?',
        a: <p>Nee. Bij het aanmelden vragen we nooit om een creditcard. Je kiest een nickname en kunt meteen beginnen.</p>,
      },
      {
        q: 'Zijn de profielen echt?',
        a: <p>Nee. Chatapp.nl gebruikt fictieve profielen die als doel hebben om met gebruikers te flirten. Je herkent ze aan het persoonsicoon <FictionalIcon language="nl" /> op hun profiel, en fysiek contact met deze profielen is niet mogelijk.</p>,
      },
      {
        q: 'Kan ik via Chatapp.nl iemand ontmoeten?',
        a: <p>Chatapp.nl is chat voor je plezier. Het is niet bedoeld om afspraken of dates te maken, en omdat de profielen fictief zijn, is fysiek contact niet mogelijk.</p>,
      },
      {
        q: 'Weet iemand dat ik op Chatapp.nl zit?',
        a: <p>Alleen als je het zelf vertelt. Anderen zien je nickname, nooit je naam of e-mailadres. Er verschijnt niets op sociale media en je bepaalt zelf welke meldingen je per mail krijgt.</p>,
      },
      {
        q: 'Wie mag zich aanmelden?',
        a: <p>Alleen volwassenen. Je moet 18 jaar of ouder zijn om een profiel aan te maken op Chatapp.nl.</p>,
      },
    ],
  },
  final: {
    title: 'Je eerste berichten zijn van ons',
    text: 'Maak in een minuut een profiel aan en begin vanavond nog aan een flirt.',
    button: 'Gratis beginnen',
  },
};

export const LABELS: ChatappLabels = {
  cityLinkKind: 'Sexchat',
  now: 'nu',
  citiesNav: 'Sexchat per stad',
  moreCities: 'Chatten in andere steden',
  cityFaqTitle: (city) => `Vragen over chatten in ${city}`,
  backHome: 'Terug naar Chatapp.nl: sexchat en flirtchat',
  footerHome: 'Sexchat en flirtchat',
  footerNav: 'Chatapp.nl in Nederland',
};
